import {
    TypedUseSelectorHook,
    useSelector,
    useDispatch as useDispatchRedux,
} from 'react-redux';
import State from 'store/State';
import { IndigoDispatch } from 'store/store';

export const useAppSelector: TypedUseSelectorHook<State> = useSelector;

export const useDispatch = () => useDispatchRedux() as IndigoDispatch;
